export default `float s=4.;
    float l=0;
    p.z-=.9;
    vec3 q=p;
    s=2.;
    for(int j=0;j++<9;)
      p-=clamp(p,-1.,1.)*2.,
      p=p*(l=8.8*clamp(.72/min(dot(p,p),2.),0.,1.))+q,
      s*=l;
    return length(p)/s;
  }`